import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Content.st.css';
import { dataHooks } from '../constants';
import { WixStyleReactContext } from '../../WixStyleReactProvider/context';
import { ContentProps } from './Content.types';
import { SidePanelContext } from '../SidePanelAPI';

class Content extends PureComponent<ContentProps> {
  static displayName = 'Content';

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    noPadding: PropTypes.bool,
    stretchVertically: PropTypes.bool,
  };

  static defaultProps = {
    noPadding: false,
    stretchVertically: true,
  };

  render() {
    const { children, className, noPadding, stretchVertically } = this.props;
    return (
      <SidePanelContext.Consumer>
        {({ skin }) => (
          <WixStyleReactContext.Consumer>
            {({ newColorsBranding }) => (
              <div
                className={st(
                  classes.root,
                  { noPadding, stretchVertically, newColorsBranding, skin },
                  className,
                )}
                data-hook={dataHooks.sidePanelContent}
              >
                {children}
              </div>
            )}
          </WixStyleReactContext.Consumer>
        )}
      </SidePanelContext.Consumer>
    );
  }
}

export default Content;
